import { render, staticRenderFns } from "./declarations.vue?vue&type=template&id=051eb203"
import script from "./declarations.ts?vue&type=script&lang=js&external"
export * from "./declarations.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports